/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';
const addCalendarButton = {

	$dombuttonContainer: $('.qlwapp-container'),
	$linkHref: $('.calendar-link-item'),

	init: function() {
		this.bindEvents();
	},

	bindEvents: function() {
		if (this.$dombuttonContainer.length > 0 && this.$linkHref.length > 0) {
			this.$dombuttonContainer.append('<a class="link-calendar qlwapp-toggle" href="'+this.$linkHref[0].href+'" target="'+this.$linkHref[0].getAttribute('target')+'"><svg xmlns="http://www.w3.org/2000/svg" width="19.688" height="17.5" viewBox="0 0 19.688 17.5"><path id="Path_18764" data-name="Path 18764" d="M5.165-12.687h4.953v-1.367a.819.819,0,0,1,.82-.82.819.819,0,0,1,.82.82v1.367h1.367A2.188,2.188,0,0,1,15.313-10.5v2.188H1.61V.438a.569.569,0,0,0,.547.547H9.724a6.026,6.026,0,0,0,1.583,1.641H2.188A2.188,2.188,0,0,1,0,.438V-10.5a2.187,2.187,0,0,1,2.188-2.187H3.555v-1.367a.819.819,0,0,1,.82-.82.819.819,0,0,1,.82.82ZM19.688-2.3a4.923,4.923,0,0,1-4.922,4.922A4.95,4.95,0,0,1,9.813-2.3a4.95,4.95,0,0,1,4.953-4.922A4.923,4.923,0,0,1,19.688-2.3ZM14.219-4.515v1.641H12.578a.57.57,0,0,0-.547.547.53.53,0,0,0,.547.547h1.641V-.14a.53.53,0,0,0,.547.547.53.53,0,0,0,.547-.547V-1.781h1.641a.53.53,0,0,0,.547-.547.57.57,0,0,0-.547-.547H15.313V-4.515a.57.57,0,0,0-.547-.547A.57.57,0,0,0,14.219-4.515Z" transform="translate(0 14.875)" fill="#fff"/></svg><span class="calendar-text"> '+this.$linkHref[0].innerText+'</span></a>');
		}
	},
};

export default addCalendarButton;
